var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.532,
    height: 41.515,
    viewBox: "0 0 31.532 41.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "consultation",
    transform: "translate(-834 -1166.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74460",
    "data-name": "Path 74460",
    d: "M840.684,1248.175v-2.845c0-11.44,18.182-11.44,18.182,0v3.06c-.1,5.885-4.268,10.543-9.257,10.446-4.95-.1-8.906-4.853-8.906-10.679Zm14.012,11.966-1.228-.526c-.6.468-1.89,1.832-2.494,2.417v9.354l-1.169,1.169-1.169-1.169v-9.335c-.624-.624-1.91-1.929-2.553-2.416a31.8,31.8,0,0,1-5.827,1.91c-2.982.721-5.2,1.267-5.437,4.638L834,1278.265h31.532l-.818-12.083c-.331-4.813-4.891-3.878-10.036-6.041Z",
    transform: "translate(0 -70.149)",
    fill: "#fe6831"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.5f3af604817f88c19c305f3bfa43266e.svg";
export { ForwardRef as ReactComponent };